<ngx-smart-modal #myModal1 identifier="myModal1">
    <h2 class="modalError">Please login and subscribe to access this content.</h2>
    <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
  </ngx-smart-modal>
  <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
    <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
    <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
  </ngx-smart-modal> -->
  <div id="content-wrapper"><iframe src="//iframe.dacast.com/b/120436/c/489905" width="590" height="431" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe></div>